<template>
  <div id="app" v-if="isLoaded && seo.path !== ''">

    <!-- <Icons /> -->
    <Header v-if="page.entryType !== 'popups'" />

    <router-view class="u-margin-top u-margin-top-large@tablet"></router-view>

    <Footer v-if="page.entryType !== 'popups'" />

    <div class="c-bg-anim">
      <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="468.4px"
        height="584.1px" viewBox="0 0 468.4 584.1" style="enable-background:new 0 0 468.4 584.1;" xml:space="preserve">
      <defs>
      </defs>
      <path class="c-bg-anim__path" d="M468.4,540.7c0,0-397.6,97.8-456.4,0c-9-15,25.5-48,24.6-65.4C35.9,460.4,16.9,435.1,12,421c-5.1-14.6-11.7-45.1-12-60.6
        c-0.3-15.6,7.2-46.4,12-61.3c4.5-13.8,18.6-40.4,19-54.9c0.7-23.7-19.6-69.2-19-93c0.4-15.6,11.6-45.7,11.3-61.3
        C23,77.4,4.4,50.8,12,40.7c68.1-91.5,456.4,0,456.4,0V540.7z"/>
      </svg>
    </div>

    <Cookies v-if="cookie === ' '" />

  </div>

</template>

<script>
import { mapState } from 'vuex'
import Icons from '@/components/icons/Icons'
import Header from '@/components/Header'
import Footer from '@/components/Footer'
import Cookies from '@/components/Cookies'
import { getCookie } from '@/utils/cookies'

export default {
  name: 'app',

  data () {
      return {
        cookie: 'Not Visible',
        introEnded: false,
        bgAnimShape: 'M473.3,540.7c0,0-404,122.5-462.8,24.7c-9-15,44.5-51.6,43.7-69c-0.7-14.9-45.7-46.5-50.7-60.6 c-5.1-14.6,49.6-58.5,49.3-73.9c-0.3-15.6-26.6-49.2-21.8-64.1c4.5-13.8-31.4-47.4-31-62c0.7-23.7,39.6-62.2,40.1-85.9 C40.5,134.4,0.3,107,0,91.5c-0.3-12.7,9.3-40.6,16.9-50.8c68.1-91.5,456.4,0,456.4,0V540.7z'
      }
  },

  beforeMount () {
    let type = this.type

    if (!type) {
      type = getCookie('splashOption')
      this.$store.commit('setType', { type })
    }

    if (!type) {
      const slug = this.$route.path
      const lang = this.$route.params.lang
      this.$store.commit('setRedirectPage', { slug: slug })
      this.$router.push('/' + lang)
    }
  },

  mounted () {
      window.scrollTo(0, 0)
      const _this = this
      this.readCookie()

      this.$router.beforeEach((to, from, next) => {
        if (to !== from) {
          const lang = to.params.lang
          let slug = to.path.replace('/' + lang, '')
          if (slug === '') {
            slug = '/'
          }
          if (this.seo[slug] === undefined) {
            _this.$store.dispatch('getSeo', { slug: slug })
          } else {
            _this.$store.commit('setSeoPath', { path: slug })
          }
        }

        if (to.params.lang !== from.params.lang) {
          const lang = to.params.lang
          this.$store.dispatch('getGlobals', { lang: lang })
        }

        next()
      })
    },

    methods: {
      readCookie () {
        const cookie = getCookie('cookiebar')

        if (cookie) {
          this.cookie = cookie
          return false
        }

        this.cookie = ' '
      }
    },

  computed: {
    isLoaded () {
      return this.$store.state.translationsLoaded
    },

    ...mapState({
      seo: state => state.seo,
      type: state => state.type,
      page: state => state.page,
      redirectPage: state => state.redirectPage
    })
  },

  // INCLUDED COMPONENTS
  components: {
    Icons,
    Header,
    Footer,
    Cookies
  }
}
</script>

<style lang="scss">
  @import './assets/_scss/main.scss';
</style>
